import router from '@/router';
import { HomePageLoadEvent } from '@/services/analytics/events';
import { AdobePageLoadEvent } from './adobe-page-load';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { WebPageDetails } from '../models';

export class AdobeHomePageLoadEvent extends AdobePageLoadEvent {
  constructor(event: HomePageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if (!store.state.adobe.hasHomePageBeenViewed) {
      services.analytics.setHomePageHasBeenViewed();
    }
    
    Object.assign(this.web.webPageDetails, {
      pageType: 'home',
      siteSection: 'home',
      name: `home:order`,
      pageViews: { value: 1 },
    } as WebPageDetails);

    if (router.currentRoute.hash == '#menu' || event.isTopLevelMenuInView) {
      this.web.webPageDetails.menuPageViews = { value: 1 };
      this.web.webPageDetails.name = 'home:home-order-now-menu';
      this.commerce.menuListViews = { value: 1 };

      if (!services.order.getCurrentOrder()) {
        this.commerce.startOrder = { value: 1 };
      }
    }
  }
}
